import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 12.69v2.812h2.813l8.295-8.295-2.813-2.813zm13.283-7.658a.747.747 0 0 0 0-1.058L13.528 2.22a.747.747 0 0 0-1.058 0l-1.373 1.373 2.813 2.812z"
    }, null, -1)
  ])))
}
export default { render: render }